export default __webpack_public_path__ + "38db56a2cb1fbfd85e877250286f204d.svg";